import { useQuery, UseQueryResult } from "react-query";
import axios from "axios";
import Config from "../config/auth.json";

const fetchViewUrl = async (s3Key: string): Promise<string> => {
  const token = JSON.parse(window.localStorage.getItem("okta-token-storage") || "{}")?.accessToken?.accessToken;
  const response = await axios.get(`${Config.endpoint}contractsservice/contracts/view`, {
    headers: { Authorization: `Bearer ${token}` },
    params: { key: s3Key },
  });
  return response.data as string;
};

export const useGetContractView = (s3Key: string | null): UseQueryResult<string> => {
  return useQuery(
    ["contract-view", s3Key],
    () => fetchViewUrl(s3Key!),
    {
      enabled: false,
      retry: false,
    },
  );
};
